import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import { queryKeys } from "./keys";

async function fetchPersonSkills() {
  const resp = await API.getAsync("/Person/Skills");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load skills");
  }
  const data = resp.jsonData || {};
  return {
    personSkills: Array.isArray(data.personSkills) ? data.personSkills : [],
    skills: Array.isArray(data.skills) ? data.skills : [],
  };
}

export function usePersonSkillsQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.personSkills(),
    queryFn: fetchPersonSkills,
    ...options,
  });
}

/** Invalidate skills Query (and careers skills catalog when present). */
export async function refreshPersonSkillsData(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.personSkills() });
  await queryClient.invalidateQueries({ queryKey: queryKeys.careers() });
  await queryClient.refetchQueries({ queryKey: queryKeys.personSkills() });
}

export function useRefreshPersonSkills() {
  const queryClient = useQueryClient();
  return () => refreshPersonSkillsData(queryClient);
}
